import { PostJobStep } from '../../../../../store/workspace/types';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { CodeBlock, dracula } from 'react-code-blocks';
import Toggle from '../../../../../components/Toggle';
import Button from '../../../../../components/Button';
import { Dispatch, SetStateAction, useState } from 'react';
import styles from './style.module.scss';
import { AIIcon, ChevronDownIcon, EditIcon, ResetRedIcon } from '../../../../../assets/icons';
import { setEditMultipleChoiceQuestionManuallyModal, setRegenerateMultipleChoiceQuestionByAIModal } from '../../../../../store/workspace/slice';
import { useDispatch } from '../../../../../store/store';
import { MultipleChoiceQuestionDetail, } from '../../../../../store/workspace/types';


interface Props {
    takingMultipleChoiceExam: boolean;
    isLoading: boolean;
    selectedIndex: number | null;
    showEditList: boolean;
    setSelectedQuestion: Dispatch<SetStateAction<MultipleChoiceQuestionDetail | null>>;
    setSelectedIndex: Dispatch<SetStateAction<number | null>>;
    setShowEditList: Dispatch<SetStateAction<boolean>>;
    setStep: (step: PostJobStep) => void;
    multipleChoiceExamQuestions: MultipleChoiceQuestionDetail[];
    setTakingMultipleChoiceExam: Dispatch<SetStateAction<boolean>>;
    submitFunction: () => void;
    goToPreviousStep: () => void;
    handleResetAllToDefaults: () => void;
    handleResetSingleQuestionToDefault: (e: React.MouseEvent<HTMLDivElement>, index: number) => void;
};

export default function EditMultipleChoiceExamDetail(props: Props) {
    const {
        setStep,
        takingMultipleChoiceExam,
        setTakingMultipleChoiceExam,
        multipleChoiceExamQuestions,
        selectedIndex,
        isLoading,
        setSelectedIndex,
        setShowEditList,
        showEditList,
        setSelectedQuestion,
        submitFunction,
        goToPreviousStep,
        handleResetAllToDefaults,
        handleResetSingleQuestionToDefault,
    } = props;

    const dispatch = useDispatch();
    const [expandedCards, setExpandedCards] = useState<number[]>([]);

    const toggleCard = (index: number) => {
        setExpandedCards(prev => {
            if (prev.includes(index)) {
                return prev.filter(i => i !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    const handleEditManually = (e: React.MouseEvent<HTMLDivElement>, question: MultipleChoiceQuestionDetail) => {
        e.stopPropagation();
        dispatch(setEditMultipleChoiceQuestionManuallyModal(true));
        setShowEditList(false);
        setSelectedQuestion(question);
    }

    const handleRegenerateByAI = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        dispatch(setRegenerateMultipleChoiceQuestionByAIModal(true))
        setShowEditList(false);
    }

    const clickOnEdit = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
        e.stopPropagation();
        setShowEditList(true);
        setSelectedIndex(index);
    }

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.header}>
                <span className={styles.title}>Step 3 - Multiple choice exam</span>
                {multipleChoiceExamQuestions.some(q => q.isEdited) && <div className={styles.reset} onClick={handleResetAllToDefaults}>
                    <ResetRedIcon />
                    <span>Reset all to defaults</span>
                </div>}
            </div>
            {/* <div className={styles.activate}>
                <span className={styles.activate_title}>
                    Generate multiple choice exam
                </span>
                <Toggle
                    toggled={takingMultipleChoiceExam}
                    setToggle={() => setTakingMultipleChoiceExam(prev => !prev)}
                />
            </div> */}

            <div className={styles.main} onClick={() => setSelectedIndex(null)}>
                <div className={styles.table}>
                    <table>
                        <thead>
                            <th>Questions & Answers</th>
                            <th>Level</th>
                            <th>Type</th>
                        </thead>
                        <tbody>
                            {multipleChoiceExamQuestions.map((q, ind) =>
                                <tr>
                                    <td>
                                        <div className={styles.question}>
                                            <div
                                                className={styles.question_edit}
                                                onClick={(e) => clickOnEdit(e, ind)}
                                                data-is-edited={q.isEdited}
                                            >
                                                <span>Edit</span>
                                                <ChevronDownIcon />
                                                {(showEditList && selectedIndex === ind) &&
                                                    <div className={styles.question_edit_options}>
                                                        <div className={styles.question_edit_options_item} onClick={(e) => handleEditManually(e, q)}>
                                                            <EditIcon />
                                                            <span>Edit manually</span>
                                                        </div>
                                                        <div className={styles.question_edit_options_item} onClick={handleRegenerateByAI}>
                                                            <AIIcon />
                                                            <span>AI regenerate</span>
                                                        </div>
                                                        {q.isEdited && <div className={styles.question_edit_options_item} onClick={(e) => handleResetSingleQuestionToDefault(e, ind)}>
                                                            <ResetRedIcon />
                                                            <span>Reset to default</span>
                                                        </div>}
                                                    </div>}
                                            </div>
                                            {ind + 1} - {q.question.split('```')[0].split(/(\`.*?\`)/g).map(i => {
                                                if (i.startsWith('`')) {
                                                    return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                                } else {
                                                    return <span>{i}</span>
                                                }
                                            })}
                                        </div>
                                        <div className={styles.codeBlock}>
                                            {q.question.includes('```') && <CodeBlock
                                                text={q.question.split('```')[1]}
                                                language={'python'}
                                                showLineNumbers={true}
                                                theme={dracula}
                                            />}
                                        </div>
                                        <span className={styles.question}>{q.question.split('```')[2]?.split(/(\`.*?\`)/g).map(i => {
                                            if (i.startsWith('`')) {
                                                return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                            } else {
                                                return <span>{i}</span>
                                            }
                                        })}</span>
                                        <div className={styles.options}>
                                            {q.choices.map((choice, indx) => <div className={styles.option}>
                                                <span
                                                    className={styles.option_index}
                                                    data-correct-answer={q.answer === indx}
                                                >
                                                    {indx + 1}
                                                </span> - &nbsp;
                                                {choice.includes('```') ?
                                                    <div className={styles.code_block}>
                                                        <CodeBlock
                                                            text={choice.split('```')[1]}
                                                            language={'python'}
                                                            showLineNumbers={true}
                                                            theme={dracula}
                                                        />
                                                    </div>
                                                    : choice.split(/(\`.*?\`)/g).map(i => {
                                                        if (i.startsWith('`')) {
                                                            return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                                        } else {
                                                            return <span>{i}</span>
                                                        }
                                                    })}
                                            </div>)}
                                        </div>
                                    </td>
                                    <td style={{ textTransform: 'capitalize' }}>{q.level}</td>
                                    <td style={{ textTransform: 'capitalize' }}>{q.type}</td>
                                </tr>)}
                        </tbody>
                    </table>
                </div>

                <div className={styles.mobile_list}>
                    {multipleChoiceExamQuestions.map((q, ind) => {
                        const { choices, answer, question, level, type } = q;
                        const isExpanded = expandedCards.includes(ind);
                        return (
                            <div className={styles.card}>
                                <div
                                    className={styles.card_header}
                                    onClick={() => toggleCard(ind)}
                                >
                                    <span>Question {ind + 1}</span>
                                    <ChevronDownIcon style={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }} />
                                </div>
                                {isExpanded && <div className={styles.card_body}>
                                    <div className={styles.card_body_section}>
                                        <div className={styles.card_body_section_content}>
                                            <span className={styles.question}>
                                                {question.split('```')[0].split(/(\`.*?\`)/g).map(i => {
                                                    if (i.startsWith('`')) {
                                                        return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                                    } else {
                                                        return <span>{i}</span>
                                                    }
                                                })}
                                            </span>
                                            {question.includes('```') && <div className={styles.codeBlock}>
                                                <CodeBlock
                                                    text={question.split('```')[1]}
                                                    language={'python'}
                                                    showLineNumbers={true}
                                                    theme={dracula}
                                                />
                                            </div>}
                                            <span className={styles.question}>{question.split('```')[2]?.split(/(\`.*?\`)/g).map(i => {
                                                if (i.startsWith('`')) {
                                                    return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                                } else {
                                                    return <span>{i}</span>
                                                }
                                            })}</span>
                                            <div className={styles.options}>
                                                {choices.map((choice, indx) => <div className={styles.option}>
                                                    <span
                                                        className={styles.option_index}
                                                        data-correct-answer={answer === indx}
                                                    >
                                                        {indx + 1}
                                                    </span>
                                                    <span>-</span>
                                                    {choice.includes('```') ?
                                                        <div className={styles.code_block}>
                                                            <CodeBlock
                                                                text={choice.split('```')[1]}
                                                                language={'python'}
                                                                showLineNumbers={true}
                                                                theme={dracula}
                                                            />
                                                        </div>
                                                        : choice.split(/(\`.*?\`)/g).map(i => {
                                                            if (i.startsWith('`')) {
                                                                return <code className={styles.code}>{i.slice(1, i.length - 1)}</code>
                                                            } else {
                                                                return <span>{i}</span>
                                                            }
                                                        })}
                                                </div>)}
                                            </div>

                                        </div>
                                    </div>
                                    <div className={styles.card_body_section}>
                                        <div className={styles.card_body_section_title}>
                                            <span>Level</span>
                                            <span>{level}</span>
                                        </div>
                                    </div>
                                    <div className={styles.card_body_section}>
                                        <div className={styles.card_body_section_title}>
                                            <span>Type</span>
                                            <span>{type}</span>
                                        </div>
                                    </div>
                                    <div
                                        className={styles.question_edit}
                                        onClick={(e) => clickOnEdit(e, ind)}
                                        data-is-edited={q.isEdited}
                                    >
                                        <span>Edit</span>
                                        <ChevronDownIcon />
                                        {(showEditList && selectedIndex === ind) &&
                                            <div className={styles.question_edit_options}>
                                                <div className={styles.question_edit_options_item} onClick={(e) => handleEditManually(e, q)}>
                                                    <EditIcon />
                                                    <span>Edit manually</span>
                                                </div>
                                                <div className={styles.question_edit_options_item} onClick={handleRegenerateByAI}>
                                                    <AIIcon />
                                                    <span>AI regenerate</span>
                                                </div>
                                                {q.isEdited && <div className={styles.question_edit_options_item} onClick={(e) => handleResetSingleQuestionToDefault(e, ind)}>
                                                    <ResetRedIcon />
                                                    <span>Reset to default</span>
                                                </div>}
                                            </div>}
                                    </div>
                                </div>}
                            </div>)
                    })}
                </div>
            </div>

            <div className={styles.actions}>
                <Button
                    text='Back'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={goToPreviousStep}
                />
                <Button
                    type='Primary'
                    text='Save & Continue'
                    className={styles.actions_btn}
                    onClick={submitFunction}
                    loading={isLoading}
                />
            </div>
        </MotionWrapper>
    )
}
